import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
    selector: '[glMousedownOutside]',
    standalone: false
})
export class MousedownOutsideDirective {
  @Input() public elementToIgnore: ElementRef<HTMLElement>;
  public classToIgnore = 'cdk-overlay-container';
  @Output() public glMousedownOutside = new EventEmitter();
  private wasClickedInsideElement = false;

  constructor(protected el: ElementRef<HTMLElement>) {}

  @HostListener('pointerdown')
  public onPointerDown(): void {
    this.wasClickedInsideElement = true;
  }

  @HostListener('document:pointerdown', ['$event'])
  public onDocumentClick(event: PointerEvent): void {
    if (this.wasClickedInsideElement) {
      this.wasClickedInsideElement = false;
      return;
    }

    const path = (event.composedPath?.() ?? []) as HTMLElement[];
    if (this.classToIgnore) {
      const excludedClicked = path.some(
        (element) => element.classList?.contains(this.classToIgnore),
      );
      if (excludedClicked) {
        return;
      }
    }

    const host = this.el.nativeElement;
    const clickedInsideHost = path.includes(host);
    const clickedInsideIgnoredElement =
      this.elementToIgnore?.nativeElement &&
      path.includes(this.elementToIgnore.nativeElement);

    if (!clickedInsideHost && !clickedInsideIgnoredElement) {
      this.glMousedownOutside.emit();
    }

    this.wasClickedInsideElement = false;
  }
}
